import { Box, Typography } from "@mui/material";
import AppBreadcrumbs from "../../app/components/AppBreadcrumbs";
import { fetchAboutByName } from "./aboutsSlice";
import { useAppDispatch } from "../../app/store/configureStore";
import { useEffect } from "react";
import useAbouts from "../../app/hooks/useAbouts";
import DOMPurify from "isomorphic-dompurify";

export default function References() {
    const dispatch = useAppDispatch();
    const { abouts } = useAbouts();
    const aboutName = 'references'; // Przykładowa nazwa, którą chcesz znaleźć
    const about = abouts.find(a => a.name === aboutName); // Wyszukuje po nazwie, jeśli masz pole 'name' w swoich danych

    console.log(about?.text);

    useEffect(() => {
        dispatch(fetchAboutByName(aboutName));
    }, [dispatch, aboutName]);

    let cleanHTML = '';
    if (about?.text) {
        cleanHTML = DOMPurify.sanitize(about?.text);
    }

    return (
        <>
            <AppBreadcrumbs />
            <Box display='flex' justifyContent='space-between'>
                <Typography sx={{ pl: 1, pb: 2 }} variant='h4'>Referencje</Typography>
            </Box>
            <Typography align="justify" gutterBottom paddingLeft={1}>
                <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />
            </Typography>
        </>
    )
}